/**
 * Map an uploads URL to the static LCP sibling produced by ensureStaticLcpWebp().
 * e.g. /backend/uploads/sections/foo.webp → .../foo-lcp-800.webp
 */
export function toStaticLcpUrl(url: string, width = 800): string {
  if (!url || url.startsWith('blob:') || url.includes(`-lcp-${width}.`)) {
    return url
  }
  if (!url.includes('/backend/uploads/') && !url.includes('/uploads/')) {
    return url
  }
  return url.replace(
    /\/([^/?#]+)\.(jpe?g|png|webp|gif)(\?[^#]*)?(#.*)?$/i,
    `/$1-lcp-${width}.webp$3$4`,
  )
}
